import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 100%;
    cursor: pointer;
    position: relative;
    display: ${(props) => (props.hidden ? "none" : "inline-block")};

    @media(min-width: 768px) {
        width: auto;
    }
`;
